// v2/hooks/useAnnouncements.js — ana sayfa: yayindaki gorsel duyurular
import { useEffect, useState } from 'react';
import { apiGet } from '../utils/api';

export default function useAnnouncements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ctrl = new AbortController();
    apiGet('/v2/announcements/', { signal: ctrl.signal })
      .then((v) => {
        if (ctrl.signal.aborted) return;
        setItems(v && v.success && Array.isArray(v.items) ? v.items : []);
      })
      .catch(() => { if (!ctrl.signal.aborted) setItems([]); })
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, []);

  return { items, loading };
}
